// لیست کشورها برای استفاده در فرم‌ها
export const COUNTRIES = [
  'ایران',
  'آلمان',
  'امارات متحده عربی',
  'انگلستان',
  'استرالیا',
  'اسپانیا',
  'ایتالیا',
  'ایرلند',
  'بلژیک',
  'ترکیه',
  'دانمارک',
  'روسیه',
  'سوئد',
  'سوئیس',
  'عراق',
  'فرانسه',
  'فنلاند',
  'قطر',
  'کانادا',
  'کویت',
  'کره جنوبی',
  'مالزی',
  'مکزیک',
  'نروژ',
  'نیوزیلند',
  'هلند',
  'ژاپن',
  'چین',
  'آمریکا',
  'عربستان سعودی',
  'سایر'
];

export default COUNTRIES;
